// type: suffix
const typeDic = {
  image: ['gif', 'jpeg', 'jpg', 'png'],
  video: ['avi', 'mpg', 'mpeg', 'rm', 'rmvb', 'mov']
}

export function getInfoFromUrl(url = '') {
  const dotLastIndex = url.lastIndexOf('.')
  const suffix = url.substr(dotLastIndex + 1).toLowerCase()
  let type = 'others'
  if (typeDic.image.includes(suffix)) {
    type = 'image'
  } else if (typeDic.video.includes(suffix)) {
    type = 'video'
  }
  return {
    suffix,
    type
  }
}
